import { Alert } from 'antd';
import { Form, Row, Col } from 'antd';
import { Select } from 'antd';
import React, { ReactElement, useEffect } from 'react';
import CcxComponentProps from '../../../../core/CcxComponent';
import styles from './DataStoreSettingsMaintenance.module.less';

interface Props extends CcxComponentProps {
    form: any;
    maintenanceDayOfWeek?: number;
    maintenanceStartHour?: number;
    onDayOfWeekChange: Function;
    onTimeWindowChange: Function;
}

function DataStoreSettingsMaintenance({
    form,
    maintenanceDayOfWeek,
    maintenanceStartHour,
    onDayOfWeekChange,
    onTimeWindowChange,
    testId = 'DataStoreSettingsMaintenance',
}: Props): ReactElement {
    useEffect(() => {
        if (maintenanceDayOfWeek) form.setFieldsValue({ maintenanceDayOfWeek });
        if (maintenanceStartHour && maintenanceStartHour >= 0) {
            form.setFieldsValue({ maintenanceStartHour });
        }
    }, [maintenanceDayOfWeek, maintenanceStartHour]);

    const handleOnDayOfWeekChange = (value: number) => {
        if (maintenanceDayOfWeek !== value) {
            onDayOfWeekChange && onDayOfWeekChange(value);
        }
    };

    const handleOnTimeWindowChange = (value: number) => {
        if (maintenanceStartHour !== value) {
            onTimeWindowChange && onTimeWindowChange(value, (value + 2) % 24);
        }
    };

    return (
        <div
            className={styles.DataStoreSettingsMaintenance}
            data-testid={testId}
        >
            <h2 data-testid={`${testId}Title`}>Maintenance</h2>
            <div className={styles.DataStoreSettingsMaintenanceDescription}>
                Please select your preferred time settings when we could work on
                regular maintenance.
            </div>
            <Form form={form} layout="vertical">
                <Row gutter={24}>
                    <Col span={8}>
                        <Form.Item noStyle>
                            <Form.Item
                                name="maintenanceDayOfWeek"
                                label="Day of the week"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please select a day',
                                    },
                                ]}
                            >
                                <Select
                                    data-testid={`${testId}DataStoreDayOfWeekSelect`}
                                    placeholder="Select a day"
                                    size="large"
                                    onChange={handleOnDayOfWeekChange}
                                >
                                    <Select.Option value={7}>
                                        Sunday
                                    </Select.Option>
                                    <Select.Option value={1}>
                                        Monday
                                    </Select.Option>
                                    <Select.Option value={2}>
                                        Tuesday
                                    </Select.Option>
                                    <Select.Option value={3}>
                                        Wednesday
                                    </Select.Option>
                                    <Select.Option value={4}>
                                        Thursday
                                    </Select.Option>
                                    <Select.Option value={5}>
                                        Friday
                                    </Select.Option>
                                    <Select.Option value={6}>
                                        Saturday
                                    </Select.Option>
                                </Select>
                            </Form.Item>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item noStyle>
                            <Form.Item
                                name="maintenanceStartHour"
                                label="Time slot"
                                extra="Time is displayed in UTC"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please select a time window',
                                    },
                                ]}
                            >
                                <Select
                                    data-testid={`${testId}DataStoreTimeWindow`}
                                    placeholder="Select a time window"
                                    size="large"
                                    onChange={handleOnTimeWindowChange}
                                >
                                    <Select.Option value={0}>
                                        00:00 AM - 02:00 AM
                                    </Select.Option>
                                    <Select.Option value={2}>
                                        02:00 AM - 04:00 AM
                                    </Select.Option>
                                    <Select.Option value={4}>
                                        04:00 AM - 06:00 AM
                                    </Select.Option>
                                    <Select.Option value={6}>
                                        06:00 AM - 08:00 AM
                                    </Select.Option>
                                    <Select.Option value={8}>
                                        08:00 AM - 10:00 AM
                                    </Select.Option>
                                    <Select.Option value={10}>
                                        10:00 AM - 12:00 PM
                                    </Select.Option>
                                    <Select.Option value={12}>
                                        12:00 PM - 02:00 PM
                                    </Select.Option>
                                    <Select.Option value={14}>
                                        02:00 PM - 04:00 PM
                                    </Select.Option>
                                    <Select.Option value={16}>
                                        04:00 PM - 06:00 PM
                                    </Select.Option>
                                    <Select.Option value={18}>
                                        06:00 PM - 08:00 PM
                                    </Select.Option>
                                    <Select.Option value={20}>
                                        08:00 PM - 10:00 PM
                                    </Select.Option>
                                    <Select.Option value={22}>
                                        10:00 PM - 00:00 AM
                                    </Select.Option>
                                </Select>
                            </Form.Item>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </div>
    );
}

export default DataStoreSettingsMaintenance;
